import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronTriangleUpMedium"><Path d="M15.8697 12.6068C16.4162 13.2574 15.9537 14.25 15.104 14.25H8.89599C8.04631 14.25 7.58378 13.2574 8.13028 12.6068L11.2343 8.91155C11.6339 8.43581 12.3661 8.43581 12.7657 8.91155L15.8697 12.6068Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
